'use client';

import { shouldOpenInCurrentTab } from '@/features/donations/utils/user-agent-detection.utils';

interface AutoSubmitPayFormParams {
  action: string;
  amount?: number;
  sum?: number;
  invoiceid?: string;
  hideamount?: string;
}

export function redirectToPayment({
  action,
  amount,
  sum,
  invoiceid,
  hideamount,
}: AutoSubmitPayFormParams): void {
  if (typeof window === 'undefined') {
    throw new Error('redirectToPayment must be called in browser');
  }

  if (!action) {
    throw new Error('action URL is required');
  }

  const url = new URL(action);

  const setParam = (key: string, value?: string | number) => {
    if (value === undefined || value === null) return;
    url.searchParams.set(key, String(value));
  };

  setParam('amount', amount);
  setParam('sum', sum);
  setParam('invoiceid', invoiceid);
  setParam('hideamount', hideamount);

  const finalUrl = url.toString();

  // On iOS Safari / Firefox for iOS the browser blocks popup-style navigation
  // that happens after an async call (fetch). Opening in the current tab is
  // the only reliable way to avoid the popup blocker on those browsers.
  if (shouldOpenInCurrentTab()) {
    window.location.href = finalUrl;
    return;
  }

  // For all other platforms (desktop, Android, Chrome on iOS) use a hidden
  // <a target="_blank"> — browsers don't block clicks on real anchor elements.
  const link = document.createElement('a');
  link.href = finalUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
